<template>
  
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li
          class="tabLi"
          v-for="(data,$index) in langData"
          :key="$index"
          :class="{'active':$index==0}"
        >
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a
            :class="true?'tab'+$index:''"
            data-toggle="tab"
            :href="true?'#tab-'+$index:''"
            aria-expanded="true"
            @click="showTab($event,$index)"
          >{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
      <div class="tab-content">
        <div
          :id="'tab-'+index"
          v-for="(langItem, index) in subCategoryDetail.langMap"
          :key="index"
          class="tab-pane"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t('message.subCategoryName')}}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.name"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'Name - '+langLabel(langItem.langCode)"
                      :maxlength="langItem.langCode=='en_US'?30:10"
                    />
                  </div>
                  <label class="error">{{ errors.first('Name - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Category") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <select class="form-control"  :name="'Category'+langLabel(langItem.langCode)" v-validate="'required'" v-model="subCategoryDetail.categoryId">
                      <option  value="">{{$t("message.PleaseSelect") }}</option>
                      <option  class="ng-binding" v-for="category in categoryList" v-bind:value="category.id">{{category['name'+langItem.langCode]}}</option>
                    </select>
                  </div>
                  <label class="error">{{ errors.first('Category'+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" @click="submit()">{{$t("message.Save") }}</div>
                    <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      categoryId:"",
      subCategoryDetail:{
        categoryId:''
      },
      categoryList:[]
    };
  },
  created() {
    let langMap = [];
    this.langKey.forEach(element => {
      langMap.push({ langCode: element });
    });
    this.subCategoryDetail.langMap = langMap;
    this.init();
  },
  mounted() {
    setTimeout(function(){
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    })
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj;
        obj.subCategoryId = id;
        let data = await this.$store.dispatch("getSubCategoryDetail", this.setFormData(obj));
        var langMap = [];
        this.langKey.forEach(element => {
          for(var i=0;i<data.data.result.langMap.length;i++){
            if(data.data.result.langMap[i].langCode==element){
              langMap.push(data.data.result.langMap[i])
            }
          }
        });
        data.data.result.langMap = langMap;
        this.$set(this, "subCategoryDetail", data.data.result);
      } else {
      }
      this.getCategoryList();
    },
    async getCategoryList(){
        let obj = this.getAuthObj;
        let data = await this.$store.dispatch("getCategoryList", this.setFormData(obj));
        for(var i=0;i<data.data.result.length;i++){
          for(var j=0;j<data.data.result[i].langMap.length;j++){
            if(data.data.result[i].langMap[j].langCode=="en_US"){
              data.data.result[i]['name'+'en_US'] = data.data.result[i].langMap[j].name;
            }
            if(data.data.result[i].langMap[j].langCode=="zh_HK"){
              data.data.result[i]['name'+'zh_HK'] = data.data.result[i].langMap[j].name;
            }
            if(data.data.result[i].langMap[j].langCode=="zh_CN"){
              data.data.result[i]['name'+'zh_CN'] = data.data.result[i].langMap[j].name;
            }
          }
        }
        this.$set(this, "categoryList", data.data.result);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            }, {
              name:"Cancel",
              callBack:function(){
                    that.$store.commit("setwarning", {
                      string: "",
                      boolean: false,
                    });
              }
            }]
        });
      }
    },
    async submit() {
      try {
        let vresult = await this.$validator.validate();
        if (!vresult) {
          this.fillInRequired();
          return;
        }
        let obj = this.getAuthObj;
        for(var key in this.subCategoryDetail){
          obj[key] = this.subCategoryDetail[key];
        }

        obj.langData = JSON.stringify(obj.langMap);
        if(this.$route.query.id){
           obj.subCategoryId = this.$route.query.id;
           var  data = await this.$store.dispatch("updateSubCategory", this.setFormData(obj));
        }else{
           var  data = await this.$store.dispatch("createSubCategory", this.setFormData(obj));
        }
        
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj;
        obj.subCategoryIds = [this.$route.query.id];
        let data = await this.$store.dispatch("deleteSubCategory", this.setFormData(obj));
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    changeTab: function(id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
  }
};
</script>
